import { apiClient } from '@/plugins/api'

export default {
  getTargetTimeline(targetId) {
    return apiClient.get(`phishing/target/${targetId}/timeline`);
  },

  updateTargetTimeline(targetId, companyId, payload) {
    return apiClient.put(`phishing/target/${targetId}/timeline`, {
      company_id: companyId,
      payload: payload
    });
  },
}
